import { render } from "./Evaluaciones.vue?vue&type=template&id=50f983f2&scoped=true"
import script from "./Evaluaciones.vue?vue&type=script&lang=js"
export * from "./Evaluaciones.vue?vue&type=script&lang=js"

import "./Evaluaciones.vue?vue&type=style&index=0&id=50f983f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f983f2"]])

export default __exports__